export enum PaymentConditionPeriodicity {
  DIARIO = 'DIARIO',
  SEMANAL = 'SEMANAL',
  MENSAL = 'MENSAL',
  ANUAL = 'ANUAL',
}

export const PaymentConditionPeriodicityOptions = [
  { label: 'Diário', value: PaymentConditionPeriodicity.DIARIO },
  { label: 'Semanal', value: PaymentConditionPeriodicity.SEMANAL },
  { label: 'Mensal', value: PaymentConditionPeriodicity.MENSAL },
  { label: 'Anual', value: PaymentConditionPeriodicity.ANUAL },
]
